import {SectionHeading} from ".";
import {ActionsMenu} from "base/ui/menu";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";

const SectionCard = ({
    isSidePanelOpen = null,
    headingLabel = true,
    subheader = "",
    title = "",
    secondaryAction = null,
    secondaryActions = null,
    dense = false,
    ...props
}) => {
    const cardStyle = {
        width: "100%",
    };

    const cardStyleForSidePanel = {
        overflow: "auto",
        width: {xs: 0, sm: "20%", md: "40%", lg: "68%", xl: "100%"},
    };

    const getActions = () => {
        if (secondaryAction) return secondaryAction;
        if (secondaryActions) return <ActionsMenu>{secondaryActions}</ActionsMenu>;
        else return null;
    };

    console.log(props);

    return (
        <Card
            sx={isSidePanelOpen ? cardStyleForSidePanel : cardStyle}
            component="section"
        >
            {secondaryAction || secondaryActions || title ? (
                <CardHeader
                    title={
                        <SectionHeading label={headingLabel}>{title}</SectionHeading>
                    }
                    subheader={subheader}
                    action={getActions()}
                    sx={{pb: dense ? 0 : 1}}
                />
            ) : null}
            <CardContent sx={props.contentStyle}>{props.children}</CardContent>
        </Card>
    );
};

export default SectionCard;
